<section *ngIf="!pageReady" class="hero is-fullheight" style="margin-top: -52px">
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="la-square-jelly-box la-color-change" style="margin-left: auto; margin-right: auto">
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</section>

<ng-container *ngIf="pageReady">
  <!--
  <section class="hero is-primary">
    <div class="hero-body">
      <div class="container has-text-centered">
        <h1 class="title">ShpoRite</h1>
        <h2 class="subtitle">Thank you for shopping with us!</h2>
      </div>
    </div>
  </section>
  -->

  <section class="section" style="padding-top: 1.5rem">
    <div class="container">
      <div class="columns is-multiline is-mobile">
        <!-- Order Info -->
        <div class="column is-12-mobile is-10-tablet is-offset-1-tablet">
          <div class="columns is-multiline is-mobile">
            <div class="column is-12 message">
              <div class="content">
                <p class="is-5" style="text-transform: capitalize">
                  <strong>{{ orderInfo.FULFILLMENT_TYPE }} Window</strong><br />
                  {{ orderInfo.FULFILLMENT_DATE_USA }}<br />
                  {{ orderInfo.FULFILLMENT_WINDOW_START }} - {{ orderInfo.FULFILLMENT_WINDOW_END
                  }}<br />
                </p>
                <address *ngIf="storeInfo && orderInfo.FULFILLMENT_TYPE === 'pickup'" class="subtitle is-6">
                  <strong>
                    {{ storeInfo.Sections[0].Name }}
                  </strong>
                  <br />
                  {{ storeInfo.Sections[0].Address.AddressLine1 }}<br />
                  <ng-container *ngIf="storeInfo.Sections[0].Address.AddressLine2.length > 0">
                    {{ storeInfo.Sections[0].Address.AddressLine2 }}<br />
                  </ng-container>
                  {{ storeInfo.Sections[0].Address.City }},
                  {{ storeInfo.Sections[0].Address.Region }}
                  {{ storeInfo.Sections[0].Address.PostalCode }}
                  <br />
                  {{ storeInfo.Sections[0].Phone }}
                  <!--
                  <ng-container>
                    <br />
                    <br />
                    <a
                      *ngIf="drivingDirectionsLink.Uri.length > 0"
                      href="{{ drivingDirectionsLink.Uri }}"
                      target="_blank"
                    >
                      Get Directions
                    </a>
                  </ng-container>
                  -->
                </address>
              </div>
            </div>
          </div>
        </div>

        <!-- Curbside Arrive Message -->
        <div class="column is-12-mobile is-10-tablet is-offset-1-tablet" style="margin-top: 1rem"
          *ngIf="retailStore.isCurbsideArriveEnabled && orderInfo.FULFILLMENT_TYPE === 'pickup'">
          <div class="columns is-multiline is-mobile message is-info">
            <div class="column is-12 message-body">
              <strong>Curbside pickup - Quicker!</strong> Before you leave, tap "On My Way" on the
              ShopRite app. We'll be ready with your order when you arrive.
              <br />
              <a href="https://shoprite.com/onyourway" target="_blank"> Learn More </a>
            </div>
          </div>
        </div>
        <!-- Bag Recycle Program Message -->
        <div class="column is-12-mobile is-10-tablet is-offset-1-tablet" style="margin-top: 1rem"
          *ngIf="retailStore.bagRecycleFeat.isEnabled">
          <div class="columns is-multiline is-mobile message is-success">
            <div class="column is-12 message-body" [innerHtml]="bagRecycleFeatBannerContent"></div>
          </div>
        </div>
        <!-- Substitutions -->
        <div class="column is-12-mobile is-10-tablet is-offset-1-tablet" style="margin-top: 2rem"
          *ngIf="willRecieve.length > 0">
          <div class="columns is-multiline is-mobile">
            <!-- Header -->
            <div class="column is-12">
              <div class="content">
                <p class="title is-capitalized">Substitutions</p>
                <p class="subtitle"></p>
              </div>
            </div>
            <!-- List -->
            <div class="column is-12">
              <app-product-list [list]="willRecieve" qtyField="SHOPPED_QTY" display="sub"></app-product-list>
            </div>
          </div>
        </div>
        <!-- Addon Items -->
        <!--
        <div
          class="column is-12-mobile is-10-tablet is-offset-1-tablet"
          style="margin-top: 3rem;"
          *ngIf="orderAddonItems.length > 0"
        >
          <app-order-addon-item-list [list]="orderAddonItems">
          </app-order-addon-item-list>
        </div>
        -->
        <!-- Out of Stocks -->
        <div class="column is-12-mobile is-10-tablet is-offset-1-tablet" style="margin-top: 2rem"
          *ngIf="willNotRecieve.length > 0">
          <app-order-out-of-stock-list [list]="willNotRecieve"> </app-order-out-of-stock-list>
        </div>
      </div>
    </div>
  </section>
</ng-container>